import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class CwSelectService {
    public selectOptionTopic$ = new Subject<CwSelectedOption>();
}

export interface CwSelectedOption {
    value: any
    label: string
}
